import { Injectable } from '@angular/core';

export interface GeoCoordinates {
  lat: number;
  lng: number;
}

@Injectable({ providedIn: 'root' })
export class GeolocationService {
  private coordinates: GeoCoordinates | null = null;

  constructor() {
    this.requestLocation();
  }

  getCoordinates(): GeoCoordinates | null {
    return this.coordinates;
  }

  private requestLocation(): void {
    if (!navigator.geolocation) {
      return;
    }
    navigator.geolocation.getCurrentPosition(
      position => {
        this.coordinates = { lat: position.coords.latitude, lng: position.coords.longitude };
      },
      () => {
      },
    );
  }
}
